module.exports = __webpack_public_path__ + "img/cooperation_unit_15.a2b899be.jpg";